/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_HCPCS_CODE_CLAIM_SEARCH_OBJ =
  'GET_HCPCS_CODE_CLAIM_SEARCH_OBJ';
// export const IS_LOADING = 'IS_LOADING';

export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_HCPCS_CODE_CLAIMS_DISPLAY =
  'REFRESH_HCPCS_CODE_CLAIMS_DISPLAY';
export const GET_ERROR_MSG_HCPCS_CODE = 'GET_ERROR_MSG_HCPCS_CODE';
export const SELECT_OPTION = 'SELECT_OPTION';
export const DISPLAY_SORT_BY = 'DISPLAY_SORT_BY';
export const DISPATCH_QTR_RANGE = 'DISPATCH_QTR_RANGE';
export const DISPATCH_ALL_MFG_CHECKED = 'DISPATCH_ALL_MFG_CHECKED';
export const SET_SELECTED_RESULT_HCPCS = 'SET_SELECTED_RESULT_HCPCS';
export const GET_MANUFACTURER_NAME_ACT = 'GET_MANUFACTURER_NAME_ACT';
export const GET_MANUFACTURER_ID_ACT = 'GET_MANUFACTURER_ID_ACT';
export const SET_MANUFACTURERS_LIST = 'SET_MANUFACTURERS_LIST';
export const SET_DETAIL_REPORT_TYPE_QUARTER = 'SET_DETAIL_REPORT_TYPE_QUARTER';
export const SET_SUMMARY_REPORT_TYPE_QUARTER =
  'SET_SUMMARY_REPORT_TYPE_QUARTER';
export const SET_SUMMARY_REPORT_TYPE_MANUFACTURER =
  'SET_SUMMARY_REPORT_TYPE_MANUFACTURER';
export const SET_DETAIL_REPORT_TYPE_NDC = 'SET_DETAIL_REPORT_TYPE_NDC';
export const REFRESH_HCPCS_CODE_CLAIMS = 'REFRESH_HCPCS_CODE_CLAIMS';
export const SET_DISPLAY_OBJ_HCPCS_CLAIMS = 'SET_DISPLAY_OBJ_HCPCS_CLAIMS';
export const SET_PAGINATION_INDEX_HCPCS_CLAIMS =
  'SET_PAGINATION_INDEX_HCPCS_CLAIMS';
export const EXPORT_TO_ALL_DATA = 'EXPORT_TO_ALL_DATA';
